<!--
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-06-20 11:24:14
 * @LastEditors: 陈钊贤
 * @Description: 
 * @LastEditTime: 2021-04-15 09:49:12
--> 
<template>
  <span class="pi-user-tag">
    <img src="../../../assets/image/my-type.png"
          alt="" v-if="vipType == 0">
    <img src="../../../assets/image/my-type-2.png"
          alt="" v-else-if="vipType == 1">
    <img src="../../../assets/image/my-type-3.png"
          alt="" v-else-if="vipType == 2">
    <img src="../../../assets/image/my-type-4.png"
          alt="" v-else-if="vipType == 3">
    <img src="../../../assets/image/my-type-5.png"
          alt="" v-else-if="vipType == 4">
    <img src="../../../assets/image/my-type.png"
          alt="" v-else>
    <template v-if="userType == 2">
      
      <img src="../../../assets/image/my-type-ent.png"
           alt="">

    </template>
    <template v-if="userType == 3">
      
      <img src="../../../assets/image/my-type-pay.png"
           alt="">
    </template>
    <template v-if="userType == 4">
      
      <img src="../../../assets/image/my-type-pay.png"
           alt="">
      
    </template>
  </span>
</template>
<script>
export default {
  name: "pi-user-tag",
  props: {
    userType: {  // 普通会员/企业会员/企业支付/企业管理员
      type: Number,
      default: 1
    },
    vipType: {   // 普通会员/白银会员/黄金会员...
      type: Number,
      default: 0
    }
  }
};
</script>
<style lang="less">
.pi-user-tag{
  img {
    width: 0.85rem;
    vertical-align: top;
    margin-right: 0.2rem;
  }
}
</style>